import { COLORS } from '@btime/constants'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { FlexCol } from '../../../../../components/structure/FlexGrid'
import { Text } from '../../../../../components/presentation/Text'
import Center from '../../../../../components/helpers/Center'
import Icon from '../../../../../components/shapes/Icon'
import QuestionTypeIconText from '../questionTypes/QuestionTypeIconText'
import Tooltip from '../../../../../components/helpers/Tooltip'

const InfoTag = ({ condition, icon, label, color }) => {
  if (!condition) return false

  return (
    <Tooltip
      actionContent={
        <Center>
          <Icon name={icon} color={color} size="1rem" />
        </Center>
      }
    >
      <Text>{label}</Text>
    </Tooltip>
  )
}

const QuestionInfoTags = ({ question }) => {
  const { t } = useTranslation('editChecklist')
  const {
    notesEnabled,
    notesRequired,
    photosEnabled,
    photosRequired,
    private: privateQuestion,
    defaultValue,
    required,
    nonComplianceConditions,
    childDisplayConditions,
    data
  } = question

  return (
    <>
      <InfoTag
        condition={!!childDisplayConditions?.length}
        label={t('containsLogic')}
        icon="BsToggles"
        color={COLORS.dark4}
      />
      <InfoTag
        condition={nonComplianceConditions?.some(item => !!item.operator && ![null, undefined].includes(item.value))}
        label={t('questionWithNonComplianceConfig')}
        icon="BsExclamationTriangle"
        color={COLORS.dark4}
      />
      <InfoTag
        condition={![undefined, null].includes(defaultValue) || data?.defaultValue}
        label={t('predefinedDefaultValue')}
        icon="BsLayersHalf"
        color={COLORS.dark4}
      />
      <InfoTag
        condition={notesEnabled}
        label={notesRequired ? t('requiredAnnotations') : t('allowAnnotations')}
        icon="BsBlockquoteLeft"
        color={notesRequired ? COLORS.red : COLORS.dark4}
      />
      <InfoTag
        condition={photosEnabled}
        label={photosRequired ? t('requiredPhotos') : t('allowPhotos')}
        icon="BsCamera"
        color={photosRequired ? COLORS.red : COLORS.dark4}
      />
      <InfoTag condition={privateQuestion} label={t('confidential')} icon="BsEyeSlash" color={COLORS.dark4} />
      <InfoTag condition={required} label={t('required')} icon="BsExclamationCircle" color={COLORS.red} />

      <FlexCol width="22%">
        <QuestionTypeIconText question={question} questionType={question.questionType} />
      </FlexCol>
    </>
  )
}

export default QuestionInfoTags
